import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '@app/+authenticated/shared/locale/locale.service';
import { formatRelativeTime, parseDate } from '@shiftbase-com/ts-shared/utilities';

@Pipe({
  name: 'relativeDate',
  pure: true,
})
export class RelativeDatePipe implements PipeTransform {
  #localeService = inject(LocaleService);

  transform(value: Date | string | number, baseDate?: Date): string {
    if (!value) {
      return '';
    }

    const date = typeof value === 'number' ? new Date(value) : value instanceof Date ? value : parseDate(value);
    const locale = this.#localeService.getCurrentLocale();

    return formatRelativeTime(date, locale, baseDate);
  }
}
